import baseTheme from "@skv/frontend/src/styles/jsvariables-nsw.scss";
import nswVariables from "@skv/frontend/src/styles/nsw-variables.scss";

import { timingFunctions } from "polished";
import { DefaultTheme } from "styled-components";

export const nswTheme: DefaultTheme = Object.assign(
  {},
  baseTheme,
  nswVariables,
  {
    timingFnEaseOut: timingFunctions("easeOutCubic"),
  }
);
